import { ChevronLeftIcon, XIcon } from "@heroicons/react/outline";
import clsx from "clsx";
import React, { FC } from "react";
import Typography from "../Typography";
import { relative } from "path";

interface ModalHeaderProps {
  title?: string;
  className?: string;
  onClose?: () => void;
  onBack?: () => void;
  isShowBackBtn?: boolean;
}

const ModalHeader: FC<ModalHeaderProps> = ({
  title = undefined,
  onClose = undefined,
  className = "",
  onBack = undefined,
  isShowBackBtn = true,
}) => {
  const keyDownListener = (event) => {
    if (event.code === "Enter") onClose();
  };
  return (
    <div className={clsx(className,"mb-4 relative" )}>
      {isShowBackBtn && (
        <div className="absolute left-0 top-0">
          {
          onBack && (
            <ChevronLeftIcon
              onClick={onBack}
              width={24}
              height={24}
              className="cursor-pointer"
              color="zText-1"
            />
          )
          }
        </div>
      )}
      {title && (
        <Typography component="h2" variant="h4">
          <div className="text-center font-bold pb-3">{title}</div>
        </Typography>
      )}
      <div
        className="absolute right-[-16px] top-[-16px] w-6 h-6 cursor-pointer zText-4 outline-none"
        onClick={onClose}
        tabIndex={0}
        onKeyDown={(event) => keyDownListener(event)}
      >
        <XIcon width={24} height={24} />
      </div>
    </div>
  );
};

export default ModalHeader;
